module.exports = __webpack_public_path__ + "img/1548355447.6593dafd.jpg";